<template>
	<div class="class">
		<teacherNav :current="current" @info-event="myInfoEvent" @public-event="publicEvent"></teacherNav>
		<div class="class_cont bg_blue">
			<div class="class_div radius8 bs bg_white">
				<div class="class_title flex">
					<p class="f30px cl_dark">班级管理</p>
					<div class="class_title_r flex tc">
						<el-popover placement="top-start" trigger="hover">
							<div>行政班：跟学校的班级组织结构一致的班级被称为行政班。行政班里面包含班主任、学科老师。<br>教学班：为适应新高考走班制推出的教学班，科任老师可以根据学校的走班情况创建自己所教授的学科的教学班。</div>
							<el-button slot="reference" class="class_title_tip"><img src="../../../static/icon_doubt.png" /></el-button>
						</el-popover>
						<router-link to="/class_join" class="class_title_add cl_violet">加入行政班</router-link>
						<button class="class_title_set cl_violet" @click="setClass(1)">创建教学班</button>
					</div>
				</div>
				<div class="class_screen mat30">
					<div class="class_screen_l flex">
						<input type="text" placeholder="输入班级名称搜索" v-model="className" class="class_screen_input radius20" />
						<button class="class_screen_submit radius20 cl_white" @click="search">搜索</button>
					</div>
					<div class="class_screen_r flex">
						<div class="famous_screen_list flex">
							<span class="cl_gray f18px">班级类型：</span>
							<el-select v-model="typeValue" placeholder="全部" @change="typeSelect">
								<el-option v-for="(item,index) in type":key="index" :label="item.name":value="item.type"></el-option>
							</el-select>
						</div>
						<div class="famous_screen_list flex">
							<span class="cl_gray f18px">所属年级：</span>
							<el-select v-model="gradeValue" placeholder="全部" @change="gradeSelect">
								<el-option v-for="(item,index) in grade":key="index" :label="item.gradeName":value="item.gradeId"></el-option>
							</el-select>
						</div>
					</div>
				</div>
				<div class="class_batch flex mat40">
					<div class="class_batch_l f18px cl_dark">共&nbsp;<span class="cl_yel">{{list.length}}</span>&nbsp;个班级</div>
					<div class="class_batch_r flex">
						<p class="f18px cl_gray">批量操作：</p>
						<button class="class_title_set mar10" :class="{'on':check_all_show}" @click="addBatch(3)">学生加班设置</button>
						<button class="class_title_set mal10" :class="{'on':check_all_show}" @click="editBatch(4)">学生改名设置</button>
					</div>
				</div>
				<div class="class_table_cont mat15" v-if="list.length > 0">
					<table class="class_table" width="100%">
						<thead class="f18px">
							<tr>
								<th width="70px"><input type="checkbox" v-model="check_all" @change="checkAll" /></th>
								<th width="260px"><p>班级名称</p></th>
								<th width="100px"><p>班级类型</p></th>
								<th width="260px"><p>所属年级</p></th>
								<th width="100px"><p>学生人数</p></th>
								<th width="120px"><p>班主任</p></th>
								<th width="150px"><p>操作</p></th>
								<th width="210px">
									<p class="inline mar5">学生加班设置</p>
									<el-popover placement="top-start" trigger="hover" class="inline" style="font-size: 0;">
										<div>禁止学生自主加班，是禁止所有学生加入到某个班级中，防止学生重复添加，造成班级管理混乱。</div>
										<el-button slot="reference" class="class_title_tip"><img src="../../../static/icon_doubt.png" /></el-button>
									</el-popover>
								</th>
								<th width="160px">
									<p class="inline mar5">允许学生改名</p>
									<el-popover placement="top-start" trigger="hover" class="inline" style="font-size: 0;">
										<div>禁止学生改名，是防止班级学生姓名完好情况下，学生再私自改名无法辨认。</div>
										<el-button slot="reference" class="class_title_tip"><img src="../../../static/icon_doubt.png" /></el-button>
									</el-popover>
								</th>
							</tr>
						</thead>
						<tbody class="f16px cl_dark">
							<tr v-for="(item,index) in list" :key="index">
								<td>
									<input type="checkbox" v-model="item.check" @change="((value)=>{checkOne(index, value)})" v-if="item.is_master==1" />
									<input type="checkbox" disabled v-else />
								</td>
								<td><p>{{item.name}}</p></td>
								<td><p>{{item.class_type == "normal" ? "行政班" : "教学班"}}</p></td>
								<td><p>{{item.grade_name}}</p></td>
								<td><p>{{item.student_num}}</p></td>
								<td><p>{{item.master_user_name}}</p></td>
								<td>
									<router-link :to="{ path: '/class_details', query: { id: item.id, type: item.class_type }}" class="cl_blue">详情</router-link>
									 | 
									<span class="cur cl_blue" @click="editName(index,2)" v-if="item.is_master==1">修改名称</span>
									<span class="cl_gray" v-else>修改名称</span>
								</td>
								<td>
									<div class="famous_screen_list">
										<el-select v-model="item.is_class_set" placeholder="不限制" :disabled="item.is_master==1? false : true" @change="((value)=>{addSelect(index, value)})">
											<el-option v-for="(item,index) in addList":key="index" :label="item.name":value="item.id"></el-option>
										</el-select>
									</div>
								</td>
								<td>
									<el-switch v-model="item.is_user_edit_name" active-color="#AFA9FE" inactive-color="#ccc" :active-value="1" :inactive-value="0"
									 :disabled="item.is_master==1? false : true" @change="((value)=>{open(index, value)})"></el-switch>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="choice_empty tc f18px cl_gray" v-if="list.length == 0">
					<p>暂时没有班级，请创建或加入班级</p>
				</div>
			</div>
		</div>
		
		<!-- 创建班级 -->
		<div class="bg class_bg" @click="degreeClose" v-if="degreeShow == true"></div>
		<div class="degree class_degree bg_white radius8" :class="[{'on':degreeShow},{'small':degreeType==2},{'min':degreeType==3||degreeType==4}]">
			<div class="degree_header"><img src="../../../static/close_violet.png" @click="degreeClose" /></div>
			<div class="degree_title tc f20px" v-if="degreeType == 1">创建班级</div>
			<div class="degree_title tc f20px" v-if="degreeType == 2">修改班级名称</div>
			<div class="degree_title tc f20px" v-if="degreeType == 3">批量修改-学生加班设置</div>
			<div class="degree_title tc f20px" v-if="degreeType == 4">批量修改-允许学生改名</div>
			<div class="class_degree_cont f16px cl_dark mat30" v-if="degreeType == 1">
				<div class="class_degree_item mab30">
					<div class="class_degree_item_l">所属学校</div>
					<div class="class_degree_item_r">
						<p>{{myInfo.school_name}}</p>
					</div>
				</div>
				<div class="class_degree_item mab30">
					<div class="class_degree_item_l">选择年级</div>
					<div class="class_degree_item_r">
						<div class="famous_screen_list flex">
							<el-select v-model="set.gradeValue" placeholder="全部" @change="gradeSelect">
								<el-option v-for="(item,index) in grade2":key="index" :label="item.gradeName":value="item.gradeId"></el-option>
							</el-select>
						</div>
					</div>
				</div>
				<div class="class_degree_item mab30">
					<div class="class_degree_item_l">关联学科</div>
					<div class="class_degree_item_r">
						<div class="famous_screen_list flex">
							<el-select v-model="set.subjectValue" placeholder="全部" @change="subjectSelect">
								<el-option v-for="(item,index) in subject":key="index" :label="item.subjectName":value="item.subjectId"></el-option>
							</el-select>
						</div>
					</div>
				</div>
				<div class="class_degree_item mab30">
					<div class="class_degree_item_l">班级名称</div>
					<div class="class_degree_item_r">
						<input type="text" placeholder="不超过10个字" maxlength="10" v-model="set.className" class="class_degree_item_name" />
					</div>
				</div>
				<div class="class_degree_item mab30">
					<div class="class_degree_item_l">学生加班设置</div>
					<div class="class_degree_item_r">
						<div class="famous_screen_list flex">
							<el-select v-model="set.add" placeholder="不限制" @change="setAdd">
								<el-option v-for="(item,index) in addList":key="index" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</div>
					</div>
				</div>
				<div class="class_degree_item mab30">
					<div class="class_degree_item_l">允许学生改名</div>
					<div class="class_degree_item_r">
						<el-switch v-model="set.edit" active-color="#AFA9FE" inactive-color="#ccc" :active-value="1" :inactive-value="0"
						 @change="setEdit"></el-switch>
					</div>
				</div>
			</div>
			<div class="class_degree_cont f16px cl_dark mat30" v-if="degreeType == 2">
				<div class="class_degree_item class_degree_item_type mab20">
					<div class="class_degree_item_l">所属学校</div>
					<div class="class_degree_item_r">
						<p>{{myInfo.school_name}}</p>
						<p class="f14px cl_gray mat10">如果学校名称有误，请致电我们 <span class="cl_violet">{{public.web_phone}}</span></p>
					</div>
				</div>
				<div class="class_degree_item mab20">
					<div class="class_degree_item_l">所属年级</div>
					<div class="class_degree_item_r">
						<p>{{listCur.grade_name}}</p>
					</div>
				</div>
				<div class="class_degree_item mab20" v-if="listCur.class_type == 'tutor'">
					<div class="class_degree_item_l">所属学科</div>
					<div class="class_degree_item_r">
						<p>{{listCur.subject_name}}</p>
					</div>
				</div>
				<div class="class_degree_item mab20">
					<div class="class_degree_item_l">班级名称</div>
					<div class="class_degree_item_r">
						<input type="text" placeholder="不超过10个字" maxlength="10" v-model="edit_class_name" class="class_degree_item_name" />
					</div>
				</div>
			</div>
			<div class="class_degree_cont tc f16px cl_dark mat50 mab50" v-if="degreeType == 3">
				<label v-for="(item,index) in addList" :key="index" class="mar15 mal15">
					<input type="radio" v-model="add_batch" :value="item.id" />
					<span class="mal5">{{item.name}}</span>
				</label>
			</div>
			<div class="class_degree_cont f16px cl_dark mat50 mab50 tc" v-if="degreeType == 4">
				<label class="mar15 mal15">
					<input type="radio" v-model="edit_batch" :value="1" />
					<span class="mal5">允许学生改名</span>
				</label>
				<label class="mar15 mal15">
					<input type="radio" v-model="edit_batch" :value="0" />
					<span class="mal5">禁止学生改名</span>
				</label>
			</div>
			<div class="class_degree_btm">
				<button class="class_degree_cancel f18px cl_violet radius20 bg_white" @click="degreeClose">取消</button>
				<button class="class_degree_confirm f18px cl_white radius20" @click="confirm">确认</button>
			</div>
		</div>
	</div>
</template>

<script>
	import teacherNav from '../../components/teacher_nav.vue'
	
	export default {
		name: 'class_manage',
		components: {
			teacherNav,
		},
		props: {
			
		},
		data () {
			return {
				myInfo: {},
				public: {},
				current: {
					navCur: 1,
					listCur: 0,
					open: 0,
				},
				className: "",
				type: [
					{
						name: "全部",
						type: ""
					},{
						name: "行政班",
						type: "normal"
					},{
						name: "教学班",
						type: "tutor"
					},
				], //班级类型
				typeValue: "",
				grade: [], //年级
				gradeValue: "",
				subject: [], //学科
				subjectValue: {},
				addList: [
					{
						id: 1,
						name: "不限制",
					},{
						id: 0,
						name: "禁止学生自己加班",
					},
				],
				check_all : false,
				check_all_show: false,
				list: [], // 班级列表
				degreeShow: false,
				degreeType: 0, //1创建班级2修改名称3加班设置4改名设置
				grade2: [],
				set: {
					subjectValue: "",
					gradeValue: "",
					className: "",
					add: 1,
					edit: 1,
				},
				listCur: {},
				edit_class_name: "",
				add_batch: 1, //批量
				edit_batch: 1,
				type_batch: "",
				id_batch: "",
			}
		},
		created() {
			
		},
		mounted() {
			this.getSubject();
			this.getGrade();
			this.getList();
		},
		methods: {
			myInfoEvent (data) {
				this.myInfo = data;
			},
			publicEvent (data) {
				this.public = data;
			},
			//学科
			getSubject () {
				this.$get("/api/material/get_subject_data",{})
				.then(res => {
					this.subject = res.data;
				});
			},
			//年级
			getGrade () {
				this.$get("/api/teacher/get_school_grade_data",{
					token: localStorage.getItem("token"),
				})
				.then(res => {
					this.grade2 = this.grade2.concat(res.data);
					this.grade = res.data;
					this.grade.unshift({gradeId: "", gradeName: "全部"});
				});
			},
			//班级列表
			getList () {
				this.$get("/api/teacher/get_class_list",{
					token: localStorage.getItem("token"),
					class_name: this.className,
					class_type: this.typeValue,
					grade_id: this.gradeValue,
				})
				.then(res => {
					for (let i = 0; i < res.data.length; i++) {
						res.data[i].check = false;
					}
					this.list = res.data;
				});
			},
			//类型筛选
			typeSelect (e) {
				this.getList();
			},
			//年级筛选
			gradeSelect (e) {
				this.getList();
			},
			search () {
				if (this.className != "") {
					this.getList();
				}
			},
			subjectSelect (e) {
				
			},
			//选择
			checkOne (index,e) {
				var that = this;
				var list = that.list;
				var len = 0;
				var list_len = 0;
				var arr = [];
				for (let i = 0; i < that.list.length; i++) {
					if (list[i].is_master == 1) {
						len += 1;
						if (list[i].check == true) {
							list_len += 1;
							arr.push(list[i].id);
						}
					}
				}
				this.id_batch = arr.join(",");
				if (list_len > 0) {
					that.check_all_show = true;
				} else {
					that.check_all_show = false;
				}
				if (len == list_len) {
					that.check_all = true;
				} else {
					that.check_all = false;
				}
			},
			checkAll (e) {
				var arr = [];
				for (let i = 0; i < this.list.length; i ++) {
					if (this.list[i].is_master == 1) {
						if (this.check_all == true) {
							this.list[i].check = true;
							this.check_all_show = true;
							arr.push(this.list[i].id);
						} else {
							this.list[i].check = false;
							this.check_all_show = false;
							arr = [];
						}
					}
				}
				this.id_batch = arr.join(",");
			},
			//批量加班,改名
			postBatch (type,ids,set_val) {
				var that = this;
				that.$get("/api/teacher/post_is_class_set",{
					token: localStorage.getItem("token"),
					type: type,
					ids: ids,
					set_val: set_val,
				})
				.then(res => {
					this.$message({
						type: 'success',
						message: res.msg,
						duration: 1500,
					});
					this.getList();
					this.check_all = false;
					this.check_all_show = false;
				});
			},
			//自己加班
			addSelect (index,value) {
				var type = "is_class_set";
				var id = this.list[index].id;
				this.postBatch(type,id,value);
			},
			//学生改名
			open (index,value) {
				var type = "is_user_edit_name";
				var id = this.list[index].id;
				this.postBatch(type,id,value);
			},
			addBatch (e) {
				if (this.check_all_show == false) {
					return false
				} else {
					this.degreeShow = true;
					this.degreeType = e;
				}
			},
			editBatch (e) {
				if (this.check_all_show == false) {
					return false
				} else {
					this.degreeShow = true;
					this.degreeType = e;
				}
			},
			//创建班级
			setClass (e) {
				this.degreeShow = true;
				this.degreeType = e;
				this.set.gradeValue = this.grade2[0].gradeId;
				this.set.subjectValue = this.subject[0].subjectId;
			},
			setAdd (e) {
				
			},
			setEdit (e) {
				
			},
			confirm () {
				if (this.degreeType == 1) {
					if (this.set.className == "") {
						this.$message({
							type: 'warning',
							message: "班级姓名不能为空",
							duration: 1500,
						});
						return false
					}
					this.$get("/api/teacher/post_created_class",{
						token: localStorage.getItem("token"),
						subject_id: this.set.subjectValue,
						name: this.set.className,
						grade_id: this.set.gradeValue,
						is_class_set: this.set.add,
						is_user_edit_name: this.set.edit,
					})
					.then(res => {
						this.$message({
							type: 'success',
							message: res.msg,
							duration: 1500,
						});
						this.getList();
					});
				} else if (this.degreeType == 2) {
					this.$get("/api/teacher/post_class_name_edit",{
						token: localStorage.getItem("token"),
						id: this.listCur.id,
						name: this.edit_class_name,
					})
					.then(res => {
						this.$message({
							type: 'success',
							message: res.msg,
							duration: 1500,
						});
						this.getList();
					});
				} else if (this.degreeType == 3) {
					this.type_batch = "is_class_set";
					this.postBatch(this.type_batch,this.id_batch,this.add_batch);
				} else if (this.degreeType == 4) {
					this.type_batch = "is_user_edit_name";
					this.postBatch(this.type_batch,this.id_batch,this.edit_batch);
				}
				this.degreeShow = false;
			},
			degreeClose () {
				this.degreeShow = false;
			},
			//修改名称
			editName (index,e) {
				this.degreeShow = true;
				this.degreeType = e;
				this.listCur = this.list[index];
				this.edit_class_name = "";
			},
		},
	}
</script>

<style>
</style>
